
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rto-suite",
      function () {
        return require("private-next-pages/rto-suite/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rto-suite"])
      });
    }
  